module.exports = __webpack_public_path__ + "img/zajac.33e92068.jpg";